import { Link } from "react-router-dom";
import type { Movie } from "@/types/media";
import { formatViews, typeLabel } from "@/utils/media";

export default function HotRanking({ movies }: { movies: Movie[] }) {
  return (
    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-x-6">
      {movies.map((movie, index) => (
        <Link
          key={movie.id}
          to={`/detail/${movie.id}`}
          className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
        >
          <span
            className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
              index < 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
            }`}
          >
            {index + 1}
          </span>
          <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-200">
            <img
              src={movie.poster}
              alt={`${movie.title} 海报`}
              title={`${movie.title} - 91影视`}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <p className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-600">
                {movie.title}
              </p>
              <span className="shrink-0 rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] font-medium text-secondary-900">
                {typeLabel(movie.type)}
              </span>
            </div>
            <p className="mt-1 truncate text-xs text-foreground-500">
              {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join(" ")}
            </p>
            <div className="mt-1 flex items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <i className="ri-fire-line text-accent-500"></i>
                {formatViews(movie.views)}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-star-fill text-secondary-500"></i>
                {movie.rating.toFixed(1)}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}